import { createReducer, on } from '@ngrx/store';
import * as StopRecordActions from '../actions/stop-record.actions';
import {DvrRecord} from '../../../services/api/dvr/dvr.model';

export const stopRecordFeatureKey = 'stopRecord';

export interface State {
  record: DvrRecord | null;
  error: unknown | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(StopRecordActions.stopRecord, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(StopRecordActions.stopRecordSuccess, (_state: State, action: {data: DvrRecord}): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(StopRecordActions.stopRecordFailure, (_state: State, action: {error: unknown}): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(StopRecordActions.clearStopRecordState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

